var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export function createLocationService(dotNetLocationService) {
    return __awaiter(this, void 0, void 0, function* () {
        yield ymaps3.ready;
        return new LocationService(dotNetLocationService);
    });
}
class LocationService {
    constructor(dotNetLocationService) {
        this.dotNetLocationService = dotNetLocationService;
        navigator.permissions.query({ name: "geolocation" }).then((permissionStatus) => {
            permissionStatus.onchange = () => __awaiter(this, void 0, void 0, function* () {
                if (permissionStatus.state === "granted") {
                    const currentLocation = yield this.getCurrentLocation();
                    yield this.dotNetLocationService.invokeMethodAsync('UpdateCurrentLocation', currentLocation);
                }
                else {
                    yield this.dotNetLocationService.invokeMethodAsync('UpdateCurrentLocation', null);
                }
            });
        });
    }
    getCurrentLocation() {
        return new Promise((resolve, reject) => {
            navigator.geolocation.getCurrentPosition((position) => {
                resolve({
                    Latitude: position.coords.latitude,
                    Longitude: position.coords.longitude
                });
            }, (error) => {
                reject(`Error get location: ${error.message}`);
            });
        });
    }
    searchLocations(searchString) {
        return __awaiter(this, void 0, void 0, function* () {
            const searchResponse = yield ymaps3.search({
                center: [39.722852, 43.585475],
                bounds: [
                    [38.81882, 43.32817],
                    [40.92133, 44.23142]
                ],
                text: `${searchString}`,
                strictBounds: true
            });
            return searchResponse.map(location => ({
                latitude: location.geometry.coordinates[1],
                longitude: location.geometry.coordinates[0],
                name: location.properties.name,
                description: location.properties.description
            }));
        });
    }
}
